import { create } from "zustand";

export const useActiveTab = create((set) => ({
  activeTab: "serp",
  setActiveTab: (value) => set(() => ({ activeTab: value })),
}));
